// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AdminLayout_wrapper__CtKNa"};